import { render, staticRenderFns } from "./PermisosyRolesExport.vue?vue&type=template&id=7d8a0405"
import script from "./PermisosyRolesExport.vue?vue&type=script&lang=js"
export * from "./PermisosyRolesExport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports